export const STORE_USER = 'STORE_USER';


export const storeUserAction = user => ({
  type: STORE_USER,
  payload: user
})
